import { render, staticRenderFns } from "./uploadFiles.vue?vue&type=template&id=46a8e658&scoped=true&"
import script from "./uploadFiles.vue?vue&type=script&lang=ts&"
export * from "./uploadFiles.vue?vue&type=script&lang=ts&"
import style0 from "./uploadFiles.vue?vue&type=style&index=0&id=46a8e658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a8e658",
  null
  
)

export default component.exports